function MenuCompact(container) {
	this.container = container;

	if(this.container.nodeType !== 1) {
		return;
	}

	this.isResized = false;

	// binds
	this.onParentClick = this.onParentClick.bind(this);
	this.calculateHeights = this.calculateHeights.bind(this);

	this.parentMenuItems = this.container.querySelectorAll('.menu-item-has-children');

	this.parentMenuItems = [].slice.call(this.parentMenuItems);

	this.parentMenuItems = this.parentMenuItems.map(menuItem => {
		return {
			'element': menuItem,
			'height': menuItem.querySelector('.sub-menu').offsetHeight
		};
	});

	this.container.classList.add('js-active');

	this.parentMenuItems.forEach(menuItem => {
		let node = menuItem.element.firstChild;
		while (node && node.nodeName !== 'A') {
			node = node.nextSibbling;
		}

		if (node.nodeName === 'A') {
			node.addEventListener('click', function(event) {
				event.target.parentNode;
				this.onParentClick(event.target.parentNode);
			}.bind(this));
		}
	});

	window.addEventListener('resize', function(){
		this.isResized = true;
	}.bind(this));
}

MenuCompact.prototype.onParentClick = function(parentElement) {
	const parentMenuItem = this.getParentMenuItem(parentElement);

	parentMenuItem.element.classList.toggle('is-open');

	this.updateSubMenus(parentMenuItem);
};

MenuCompact.prototype.updateSubMenus = function(parentMenuItem) {
	this.parentMenuItems.forEach(menuItem => {

		if (menuItem == parentMenuItem && parentMenuItem.element.classList.contains('is-open')) {
			if (menuItem.height && ! this.isResized) {
				menuItem.element.querySelector('.sub-menu').setAttribute('style', 'height: ' + menuItem.height + 'px;');
			}
			else {
				parentMenuItem.element.querySelector('.sub-menu').removeAttribute('style');
			}
		}
		else {
			menuItem.element.classList.remove('is-open');
			if (!this.isResized) {
				menuItem.element.querySelector('.sub-menu').setAttribute('style', 'height: 0px;');
			}
			else {
				parentMenuItem.element.querySelector('.sub-menu').removeAttribute('style');
			}
		}
	});
};

MenuCompact.prototype.getParentMenuItem = function(parentElement) {
	for( let i=0;i<this.parentMenuItems.length;i++ ) {
		if( this.parentMenuItems[i].element == parentElement ) {
			return this.parentMenuItems[i];
		}
	}
};

// To do: not working atm
MenuCompact.prototype.calculateHeights = function() {
	this.parentMenuItems.forEach(menuItem => {
		const isOpen = menuItem.element.classList.contains('is-open');
		if (!isOpen) {
			menuItem.element.classList.remove('is-open');
		}
		menuItem.height = menuItem.element.querySelector('.sub-menu').offsetHeight;
		if (!isOpen) {
			menuItem.element.classList.add('is-open');
		}
	});
};

export default MenuCompact;